<template>
  <b-row>
    <b-col md="12">
      <component-header
        title="Language settings"
        :hasSearch="false"
        :hasReload="false"
        :hasCreate="false"
        :hasback="false"
      />
    </b-col>
    <b-col>
      <b-card>
        <div>
          <!-- <div v-if="userRole === 'Partner'">
              <h3>My Profile</h3>
              <b-card>
                <b-row>
                  <b-col md="4">
                    <div style="text-align: center">
                      <v-avatar
                        size="120"
                        style="z-index: 111; margin-bottom: -5%"
                      >
                        <img
                          :src="userLogo"
                          class="img-avatar"
                          alt="user-logo"
                        />
                      </v-avatar>
                      <div class="mt-4">
                        <c-input
                          inputType="text"
                          labelText="Username"
                          v-model="details.name"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col md="8">
                    <h4 class="text-primary">Personal Information</h4>
                    <b-row class="mt-2">
                      <b-col md="6">
                        <c-input
                          inputType="text"
                          labelText="E-mail"
                          v-model="details.email"
                        />
                      </b-col>
                      <b-col md="6">
                        <c-input
                          inputType="text"
                          labelText="Phone"
                          v-model="details.phone"
                        />
                      </b-col>
                    </b-row>
                    <h4 class="text-primary">Address Information</h4>
                    <b-row class="mt-1">
                      <b-col md="6">
                        <c-input
                          inputType="text"
                          labelText="Country"
                          v-model="address.country"
                        />
                      </b-col>
                      <b-col md="6">
                        <c-input
                          inputType="text"
                          labelText="State"
                          v-model="address.state"
                        />
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="6">
                        <c-input
                          inputType="text"
                          labelText="Street 1"
                          v-model="address.street1"
                        />
                      </b-col>

                      <b-col md="6">
                        <c-input
                          v-if="this.address.street2"
                          inputType="text"
                          labelText="Street 2"
                          v-model="address.street2"
                        />
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="6">
                        <c-input
                          inputType="text"
                          labelText="House No"
                          v-model="address.houseNumber"
                        />
                      </b-col>

                      <b-col md="6">
                        <c-input
                          inputType="text"
                          labelText="Zip"
                          v-model="address.zip"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="justify-content-center mt-3">
                  <button
                    @click.prevent="submit"
                    class="btn btn-primary sm btn-lg"
                    type="submit"
                  >
                    <i class="mdi mdi-home mr-1"></i>Submit
                  </button>
                </b-row>
              </b-card>
            </div> -->

          <div v-if="userRole === 'Tenant'">
            <b-col md="12"><h4>Language Settings</h4></b-col>
            <b-col md="12" class="language-select-field">
              <v-select
                ref="selectLanguage"
                v-model="selectedLanguage"
                :items="languages"
                item-text="name"
                item-value="id"
                return-object
                label="Select Language"
                chips
                multiple
                hint="What are the target language"
              >
                <template v-slot:prepend-item>
                  <div class="dropdown-close-header">
                    <v-btn icon small @click="closeSelectLanguage" class="close-btn">
                      <v-icon small>close</v-icon>
                    </v-btn>
                  </div>
                </template>
              </v-select>
            </b-col>
            <b-col md="12">
              <v-select
                ref="defaultLanguageSelect"
                :items="selectedLanguage"
                item-text="name"
                item-value="id"
                v-model="defaultLanguage"
                label="Default Language"
                chips
              >
                <template v-slot:prepend-item>
                  <div class="dropdown-close-header">
                    <v-btn icon small @click="closeDefaultLanguage" class="close-btn">
                      <v-icon small>close</v-icon>
                    </v-btn>
                  </div>
                </template>
              </v-select>
            </b-col>

            <!-- <b-row class="mt-1">
                <b-col md="3">
                  <v-checkbox
                    v-model="lightMode"
                    label="Enable lightMode "
                  ></v-checkbox>
                </b-col>
                <b-col md="4">
                  <v-checkbox
                    v-model="enableManufacturer"
                    label="Enable Manufacturer "
                  ></v-checkbox>
                </b-col>
              </b-row> -->
          </div>
        </div>
      </b-card>
      <b-col md="12">
        <div class="text-center language-button">
          <button
            variant="danger"
            type="button"
            class="text-uppercase btn btn-lg btn-danger"
            @click="backToProfile"
          >
            Cancel
          </button>
          <button
            variant="primary"
            @click.prevent="onSaveLanguage"
            type="button"
            class="text-uppercase btn btn-lg btn-primary"
          >
            Update
          </button>
        </div>
      </b-col>
    </b-col>
  </b-row>
</template>
<script>
import profile from "@/components/profile/profileCategory";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters, mapActions } from "vuex";
import cInput from "@/components/Common/CustomInput";
import { getReverseGeoCode } from "@/services/geocode";
import ComponentHeader from "@/components/componentNewHeader";
export default {
  components: {
    profile,
    ValidationProvider,
    ValidationObserver,
    ComponentHeader,
    cInput,
  },
  data() {
    return {
      langObj: {
        en: "English",
        bn: "Bengali",
        te: "Telugu",
        hi: "Hindi",
      },
      lightMode: true,
      enableManufacturer: false,
      paramsId: null,
      isEditMode: false,
      oldPwd: "",
      newPwd: "",
      cfmPwd: "",
      errorMessages: "",
      details: {
        name: "",
        phone: "",
        email: "",
      },
      hasAddress: false,
      address: {
        city: "",
        country: "",
        houseNumber: "",
        state: "",
        street1: "",
        zip: "",
        location: {
          coordinates: [0, 0],
        },
      },
      selectedLanguage: [],
      defaultLanguage: "",
      languages: [
        { id: "en", name: "English" },
        { id: "bn", name: "Bengali" },
        { id: "te", name: "Telugu" },
        { id: "hi", name: "Hindi" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "profileUpdate/GetmeTenant",
      tenantLanguage: "tenant/GetTenantLanguage",
      tenantPreferences: "tenant/GetTenantPreferences",
    }),
    userLogin() {
      try {
        const raw = sessionStorage.getItem("userLogin");
        return raw ? JSON.parse(raw) : {};
      } catch {
        return {};
      }
    },
    userLogo() {
      return this.userLogin?.userLogo || "img/avatars/6.jpg";
    },
    userRole() {
      return this.$store.getters["auth/getUserRole"] || this.userLogin?.role;
    },
    userId() {
      return this.$store.getters["auth/getUserID"] || this.userLogin?._id;
    },
  },
  mounted() {
    if (this.userRole === "Tenant") {
      this.getPreference(this.userId).then((result) => {
        if (result.status === 1) {
          if (
            this.tenantPreferences.languages &&
            this.tenantPreferences.languages.length > 0
          ) {
            this.tenantPreferences.languages.map((obj) => {
              this.selectedLanguage.push({
                id: obj,
                name: this.langObj[obj],
              });
            });
            this.defaultLanguage = this.tenantPreferences.defaultLanguage;
            this.lightMode = this.tenantPreferences.lightMode;
            this.enableManufacturer = this.tenantPreferences.enableManufacturer;
          }
        }
      });
    }
    this.$store.dispatch("profileUpdate/fetchmeTenant").then((d) => {
      this.details.phone = this.userInfo.authentication.phone;
      this.details.name = this.userInfo.authentication.userName;
      this.details.email = this.userInfo.authentication.email;
      this.address.city = this.userInfo.office.address.city;
      this.address.country = this.userInfo.office.address.country;
      this.address.houseNumber = this.userInfo.office.address.houseNumber;
      this.address.state = this.userInfo.office.address.state;
      this.address.street1 = this.userInfo.office.address.street1;
      this.address.street2 = this.userInfo.office.address.street2;
      this.address.zip = this.userInfo.office.address.zip;
    });
  },
  methods: {
    ...mapActions({
      updateProfile: "profileUpdate/updateTenant",
      changePassword: "profileUpdate/UpdatePassword",
      updatePreference: "tenant/updateTenantPreferences",
      getPreference: "tenant/getTenantPreferences",
    }),
    async submit() {
      const userId = this.userInfo._id;
      const data = this.userInfo;
      try {
        const data = await getReverseGeoCode(
          `${this.address.street1},${this.address.city},${this.address.state},${this.address.country}`
        );
        if (data.data.status === "OK") {
          this.address.location.coordinates = [
            data.data.results[0].geometry.location.lng,
            data.data.results[0].geometry.location.lat,
          ];
        }
      } catch (error) {}
      data.office.address = {
        ...this.address,
      };
      data.authentication.userName = this.details.name;
      data.authentication.phone = this.details.phone;
      data.authentication.email = this.details.phone;
      delete data.organization;
      delete data.authorization;
      delete data.authentication.isActive;
      delete data.authentication.otpVerified;
      delete data.authentication.loginAttempts;
      delete data.authentication.forceChangePass;
      delete data.authentication._id;
      delete data.authentication.lockUntil;
      //  delete data.organization.location.type;
      delete data.serviceable;
      delete data.archive;
      delete data._id;
      delete data.bill_to;
      delete data.businessNo;
      delete data.createdAt;
      delete data.updatedAt;
      delete data.idValidation;
      delete data.__v;
      delete data.id;
      await this.updateProfile({ id: userId, data }).then(() => {
        this.$swal({
          title: "Success",
          text: "Profile updated successfully!!",
          type: "success",
        });
      });
    },
    async onSubmit() {
      if (this.newPwd == this.cfmPwd) {
        try {
          const payload = {
            currentPassword: this.oldPwd,
            newPassword: this.newPwd,
          };
          await this.changePassword(payload);
          this.$swal({
            title: "Success",
            text: "Password updated successfully",
            type: "success",
          });
        } catch (err) {
          this.$swal({
            title: "Error!!",
            text: "Failed",
            type: "error",
          });
        }
      } else {
        this.$swal({
          title: "Error",
          text: "password and confirm password do not match",
          type: "error",
        });
      }
    },
    onSaveLanguage() {
      let languages = [];
      if (this.selectedLanguage && this.selectedLanguage.length > 0) {
        this.selectedLanguage.map((obj) => {
          languages.push(obj.id);
        });
      }
      let payload = {
        id: this.userId,
        data: {
          languages: languages,
          defaultLanguage: this.defaultLanguage ? this.defaultLanguage : "en",
          lightMode: this.lightMode,
          enableManufacturer: this.enableManufacturer,
        },
      };
      this.updatePreference(payload).then((result) => {
        this.$toasted.success("Tenant preferences updated.");
        if (result.status === 1) {
          this.getPreference(this.userId);
        }
      });
    },
    backToProfile() {
      this.$router.push("/profile/profile-info");
    },
    closeSelectLanguage() {
      this.$refs.selectLanguage && this.$refs.selectLanguage.blur();
    },
    closeDefaultLanguage() {
      this.$refs.defaultLanguageSelect && this.$refs.defaultLanguageSelect.blur();
    },
  },
  created() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
};
</script>
<style scoped>
.language-button button {
  width: 160px;
  margin-bottom: 15px;
  margin-left: 15px;
  margin-right: 15px;
}
@media (max-width: 768px) {
  .language-button button {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }
}
</style>
<style>
.dropdown-close-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 4px 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  min-height: 40px;
}
.dropdown-close-header .close-btn {
  margin-left: auto;
}
</style>
